<div class="body">
        <app-header></app-header>

    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>

<app-pop-up-politicas></app-pop-up-politicas>